import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

const thirdPage = () => (
  <Layout>
    <Seo title="Page two" />
    <div className="p-4 font-sans">
      <p className="leading-5 text-justify my-0">
        <span className="text-4xl	font-bold">Tecnologías orchata</span>
      </p>
      <p className="leading-5 text-justify my-2">
        <span className="text-lg pt-4">
          Políticas y privacidad de uso de la plataforma "Orchata Repartidores”
        </span>
      </p>
      <p className="leading-5 text-justify my-2">
        <span className="text-lg pt-4 font-bold">
          Uso de datos de ubicación
        </span>
      </p>
      <p className="leading-5 text-justify my-2">
        <span className="text-lg pt-4">
          Los presentes Términos y Condiciones de uso (en adelante los “Términos” y/o “Condiciones”, en su caso) 
          regulan el acceso o uso que usted haga, como persona, desde los Estados Unidos Mexicanos de la plataforma virtual
          Orchata Repartidores, compuesta por una aplicación para dispositivos móviles y una página web (en adelante “el servicio” o “los servicios”), 
          puestos a disposición por Tecnologías Orchata, S.A.P.I. de C.V., una sociedad mercantil constituida bajo las leyes de los Estados Unidos Mexicanos, 
          con domicilio social en Av. Lázaro Cardenas No. 506, Col. Antigua Hacienda San Agistín, 64752, Monterrey, Nuevo León, México.
        </span>
      </p>
      <p className="leading-5 text-justify my-2">
        <span className="text-lg pt-4">
          El uso de tu ubicación será para poder proporcinar el estatus en tiempo real de un pedido en curso con el cliente. Tus datos no estan comprometidos, y no se podrán compratir con nadie mas.
        </span>
      </p>
    </div>
  </Layout>
)

export default thirdPage  
